import { makeAutoObservable } from 'mobx';
import { RootStore } from './rootStore';

export class PdfStore {
  isOpen = false;
  progress = 0;
  progressLabel = '';

  constructor(private rootStore: RootStore) {
    makeAutoObservable(this);
  }

  open() {
    this.isOpen = true;
    this.progress = 0;
    this.progressLabel = '';
  }

  close() {
    this.isOpen = false;
    this.progress = 0;
    this.progressLabel = '';
  }

  setProgress(percent: number, label: string) {
    this.progress = percent;
    this.progressLabel = label;
  }
}
